import React from "react";
import { Link } from 'react-router-dom'
import './TripCard.css';
import { ReactComponent as PlaneIcon } from '../../assets/plane-icon.svg';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { ReactComponent as BudgetIcon } from '../../assets/coins-hand.svg';
import { ReactComponent as EditIcon } from '../../assets/edit-icon.svg';

const TripCard = ({ trip, abbreviateDestination, onDelete }) => {
      return (
        
        <div className="trip-card">
          <div className="delete-btn-container">
            <button className="delete-btn" onClick={() => onDelete(trip.TRIP_ID)}>✖ </button>
            <span className="delete-tip">Tidy up homepage</span>
          </div>
            <h3 className="trip-title">{trip.TRIP_NAME}</h3>

           <div className ="Trip-Details">
            <div className="trip-row">
            <div className ="trip-info-title">
             <PlaneIcon className = "trip-icon"/>
             <h4>Trip Details</h4>
             </div>
            <div className="trip-info">
              <div>{abbreviateDestination}</div>
              <div>{new Date(trip.START_DATE).toLocaleDateString()}</div>
              <div>{new Date(trip.END_DATE).toLocaleDateString()}</div>
            </div>
        </div>
            <div className="trip-shortcuts">
                <div className="shortcut-row">
                <div className="shortcut-title">
                  <FormatListBulletedIcon className = "trip-icon"/>   
                  <h4>Itinerary</h4>  
                </div>  
                <Link to={`https://tripmate-rbck.onrender.com/planner/${trip.TRIP_ID}`} className="edit-icon-link">
                <span className="edit-icon">
                   <EditIcon className ="edit-trip-icon"/> 
                    </span>
                </Link>
                </div>
                <div className="shortcut-row">
                 <div className="shortcut-title">
                  <BudgetIcon style={{ width: '24px', height: '24px', stroke: '#06004A'}} className = "trip-icon"/>
                   <h4>Budget</h4>
                    </div>
                <Link to={`/budget-saved/${trip.TRIP_ID}`}
                className="edit-icon-link">
                <span className="edit-icon">
                <EditIcon className ="edit-trip-icon"/> 
                </span>
                </Link>
            </div>
        </div>
      </div> 
    </div>  
    );
}

export default TripCard;